// src/pages/Reports/AdvanceTours.jsx
import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import Toast from '../../components/Toast/Toast';
import './AdvanceTours.css';

const AdvanceTours = () => {
  const { user, isSuperAdmin } = useAuth();

  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    fetchAdvanceTours();
  }, []);

  const fetchAdvanceTours = async () => {
    setLoading(true);
    try {
      const companyId = isSuperAdmin 
        ? localStorage.getItem('selectedCompanyId')
        : user?.companyId;

      const token = localStorage.getItem('token');
      const params = companyId ? { companyId } : {};

      const response = await api.get('/advance-tours/this-month', { params });

      if (response.data.success) {
        setEntries(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching advance tours:', error);
      setToast({ message: 'Failed to fetch advance tours', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="advance-tours-page">
      {/* Toast Notification */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}

      {/* Page Header */}
      <div className="page-header">
        <div className="breadcrumb">
          <span className="breadcrumb-item">Home</span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-item active">Dashboard</span>
        </div>
      </div>

      {/* Advance Tours Table */}
      <div className="advance-tours-section">
        <div className="section-header">
          <h3 className="section-title">Advance Tours</h3>
          <span className="section-period">| This month</span>
        </div>

        <div className="table-container">
          {loading ? (
            <div className="loading">Loading advance tours...</div>
          ) : (
            <table className="advance-tours-table">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Name</th>
                  <th>Designation</th>
                </tr>
              </thead>
              <tbody>
                {entries.length > 0 ? (
                  entries.map((entry) => (
                    <tr key={entry.sr}>
                      <td>{entry.sr}</td>
                      <td>{entry.name}</td>
                      <td>{entry.destination}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="no-data">
                      No advance tours this month
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdvanceTours;